var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bto-sb-footer-combo"},[_c('span',[_vm._v(_vm._s(_vm.t('W.Unique')))]),_c('span',{staticClass:"bto-sb-combomini3"},[_vm._v(_vm._s(_vm.t('W.Min3')))]),_c('span',{staticClass:"bto-sb-combomini4"},[_vm._v(_vm._s(_vm.t('W.Min4')))]),_c('span',{staticClass:"bto-sb-combomini5"},[_vm._v(_vm._s(_vm.t('W.Min5')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }